import { createApp } from "vue";
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import "@fortawesome/fontawesome-free/css/all.min.css";

import App from "./App.vue";
import router from "./router";

// i18n configuration
const i18n = createI18n({
  legacy: false,
  locale: "th",
  fallbackLocale: "en",
  globalInjection: true,
  messages: {
    th: {
      restaurant: {
        name: "นิราชาบู",
        management: "ระบบจัดการร้านอาหาร",
        branches: "สาขา",
        invoices: "ใบกำกับภาษี",
        dashboard: "แดชบอร์ด",
      },
      invoice: {
        taxInvoice: "ใบกำกับภาษี",
        paymentReceipt: "ใบจ่ายเงิน",
        withholdingTax: "ใบหัก ณ ที่จ่าย",
        create: "สร้างใหม่",
        edit: "แก้ไข",
        delete: "ลบ",
      },
      common: {
        save: "บันทึก",
        cancel: "ยกเลิก",
        confirm: "ยืนยัน",
        loading: "กำลังโหลด...",
        success: "สำเร็จ",
        error: "เกิดข้อผิดพลาด",
      },
    },
    en: {
      restaurant: {
        name: "Nira Shabu",
        management: "Restaurant Management System",
        branches: "Branches",
        invoices: "Invoices",
        dashboard: "Dashboard",
      },
      invoice: {
        taxInvoice: "Tax Invoice",
        paymentReceipt: "Payment Receipt",
        withholdingTax: "Withholding Tax Receipt",
        create: "Create New",
        edit: "Edit",
        delete: "Delete",
      },
      common: {
        save: "Save",
        cancel: "Cancel",
        confirm: "Confirm",
        loading: "Loading...",
        success: "Success",
        error: "Error",
      },
    },
  },
});

const app = createApp(App);
const pinia = createPinia();

// Register Element Plus Icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(ElementPlus);

app.mount("#app");

// Silence noisy Cloudflare beacon 404s by intercepting /cdn-cgi/rum.
// Only registers in production builds and only if SW is supported.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("/cdn-cgi-rum-sw.js").catch(() => {});
}
